export const movies_pages_list = [
    {
        name : "Most Popular",
        type : "popular"
    },
    {
        name : "Top Rated",
        type : "top_rated"
    },
    {
        name : "Coming Soon",
        type : "upcoming"
    },
    
]

